var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlusMembershipEvent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 10,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.794.123h-5.833A1.96 1.96 0 0 0 10 2.083v5.82a1.96 1.96 0 0 0 1.96 1.962h5.821a1.96 1.96 0 0 0 1.961-1.961V2.07A1.948 1.948 0 0 0 17.794.123Z",
  fill: "#21AB73"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.052.136H2.22a1.96 1.96 0 0 0-1.961 1.96v5.821a1.96 1.96 0 0 0 1.96 1.96H8.04A1.96 1.96 0 0 0 10 7.918V2.084A1.948 1.948 0 0 0 8.052.136Z",
  fill: "#fff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.179 5.63c-.208 0-.411.134-.52.272-.329.38-.768.678-1.343.678a1.581 1.581 0 0 1-1.589-1.572c0-.84.685-1.572 1.589-1.572.575 0 1.013.297 1.343.678.109.136.315.271.52.271.379 0 .639-.286.639-.601a.661.661 0 0 0-.106-.376c-.517-.76-1.353-1.247-2.396-1.247-1.616 0-2.877 1.247-2.877 2.847 0 1.6 1.26 2.847 2.877 2.847 1.04 0 1.88-.486 2.396-1.247a.654.654 0 0 0 .106-.376c0-.313-.262-.601-.64-.601Z",
  fill: "#1A2E80"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.072 7.853a.632.632 0 1 1-1.265 0 .632.632 0 0 1 1.265 0Z",
  fill: "#2E80FF"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.87 2.16a.632.632 0 0 0-.632.632v4.403a.632.632 0 1 0 1.265 0V2.792a.632.632 0 0 0-.632-.632Z",
  fill: "#fff"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.707 4.993a.632.632 0 0 0-.633-.632h-4.403a.632.632 0 1 0 0 1.265h4.403c.35 0 .633-.283.633-.633Z",
  fill: "#fff"
})));
export default SvgPlusMembershipEvent;